import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "course-page" */ './CoursePage'));

export const CourseBookletPage = Loadable(() => import(/* webpackChunkName: "course-page" */ './CourseBookletPage'));
